import { useTranslation } from "@opendash/i18n";
import { Tour, TourProps } from "antd";
import React, { useState } from "react";
import { useUserGuideSelect } from "../../../hooks/useUserGuideSelect";
import { TourId } from "../../../types/TourId";
import TourButton from "../TourButton";

export default () => {
  const t = useTranslation();
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(0);
  const select = useUserGuideSelect<TourId.Agency>();

  const steps: TourProps["steps"] = [
    {
      title: t("gtfs:tour.agency.start.title"),
      description: t("gtfs:tour.agency.start.description"),
    },
    {
      title: t("gtfs:tour.agency.create.title"),
      description: t("gtfs:tour.agency.create.description"),
      target: () => select(TourId.Agency.create),
      onNext() {
        select(TourId.Agency.create)?.click();
        setTimeout(() => setCurrent((prev) => prev + 1), 500);
      },
    },
    {
      title: t("gtfs:tour.agency.formular.title"),
      description: t("gtfs:tour.agency.formular.description"),
      target: () => select(TourId.Agency.modal),
      onPrev() {
        select(TourId.Agency.close)?.click();
        setCurrent((prev) => prev - 1);
      },
    },
    {
      title: t("gtfs:tour.agency.save.title"),
      description: t("gtfs:tour.agency.save.description"),
      target: () => select(TourId.Agency.save),
      onNext() {
        select(TourId.Agency.close)?.click();
        setCurrent((prev) => prev + 1);
      },
    },
    {
      title: t("gtfs:tour.agency.overview.title"),
      description: t("gtfs:tour.agency.overview.description"),
      target: () => select(TourId.Agency.overview),
      onPrev() {
        select(TourId.Agency.create)?.click();
        setTimeout(() => setCurrent((prev) => prev - 1), 500);
      },
      onNext() {
        select(TourId.Agency.overview)?.focus();
        setCurrent((prev) => prev + 1);
      },
    },
    {
      title: t("gtfs:tour.agency.end.title"),
      description: t("gtfs:tour.agency.end.description"),
    },
  ];

  function onEndTour() {
    setOpen(false);
    setCurrent(0);
    select(TourId.Agency.close)?.click();
  }

  return (
    <>
      <TourButton
        onClick={() => setOpen(true)}
        title={t("gtfs:tour.agency.button.title")}
      />
      <Tour
        steps={steps}
        open={open}
        onClose={() => onEndTour()}
        current={current}
        onChange={(cur) => setCurrent(cur)}
      />
    </>
  );
};
